import { capitalizeFirstLetter } from 'Shared/Utils';

type SVGProps = {
  src: string;
  [key: string]: any;
  clickHandler?: (event: React.MouseEvent) => void;
};

const SVG: React.FC<SVGProps> = ({ src, name, clickHandler }) => {
  return (
    <img
      src={src}
      alt={capitalizeFirstLetter(name).split('-').join(' ')}
      onClick={(event) => (clickHandler ? clickHandler(event) : null)}
    />
  );
};

export default SVG;
